import { useTranslation } from "react-i18next";
import CircleCommentIcon from "../../../../icons/circleCommentIcon";
import CircleNoteIcon from "../../../../icons/circleNoteIcon";
import CircleReloadIcon from "../../../../icons/circleReloadIcon";
import CircleContainerTruckIcon from "../../../../icons/circleContainerTruckIcon";
import ShipmentChart from "./chart";
import Notification from "./notification";
import LastUpdatedShipments from "./lastUpdatedShipments";

const EmployeesHome = () => {
  const { t } = useTranslation();
  return (
    <main className="space-y-5">
      <section className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
        <div className="flex items-start gap-4 px-6 py-4 bg-white rounded-2xl">
          <div>
            <CircleCommentIcon />
          </div>
          <div>
            <h2 className="text-lg font-medium capitalize">{t("agentReplies")}</h2>
            <p className="my-4 text-sm capitalize text-mainGray ">
              {t("numberOfReceivedReplies")}
            </p>
            <span className="text-2xl font-medium text-mainBlue">3</span>
          </div>
        </div>
        <div className="flex items-start gap-4 px-6 py-4 bg-white rounded-2xl">
          <div>
            <CircleNoteIcon />
          </div>
          <div>
            <h2 className="text-lg font-medium capitalize">{t("offerPrices")}</h2>
            <p className="my-4 text-sm capitalize text-mainGray ">{t("sentOffers")}</p>
            <span className="text-2xl font-medium text-mainBlue">3</span>
          </div>
        </div>
        <div className="flex items-start gap-4 px-6 py-4 bg-white j rounded-2xl">
          <div>
            <CircleReloadIcon />
          </div>
          <div>
            <h2 className="text-lg font-medium capitalize">{t("updatedShipments")}</h2>
            <p className="my-4 text-sm capitalize text-mainGray ">
              {t("shipmentWithUpdatesStatus")}
            </p>
            <span className="text-2xl font-medium text-mainBlue">7</span>
          </div>
        </div>
        <div className="flex items-start gap-4 px-6 py-4 bg-white rounded-2xl">
          <div>
            <CircleContainerTruckIcon />
          </div>
          <div>
            <h2 className="text-lg font-medium capitalize">{t("currentShipments")}</h2>
            <p className="my-4 text-sm capitalize text-mainGray ">
              {t("shipmentsUnderUrResponsibility")}
            </p>
            <span className="text-2xl font-medium text-mainBlue">12</span>
          </div>
        </div>
      </section>
      <div className="flex flex-wrap gap-5 lg:flex-nowrap">
        <Notification />
        <div className="w-full lg:flex-1">
          <ShipmentChart />
        </div>
      </div>
      <LastUpdatedShipments />
    </main>
  );
};

export default EmployeesHome;
